const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-header">
              <h2>About Vision Workspaces</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default About;